// WordPress API service for blog integration
const WP_API_BASE = 'https://hiaqstage.wpengine.com/wp-json/wp/v2';

export interface BlogPost {
  id: number;
  title: {
    rendered: string;
  };
  content: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  slug: string;
  date: string;
  author: number;
  featured_media: number;
  _embedded?: {
    author: Array<{
      name: string;
      slug: string;
    }>;
    'wp:featuredmedia'?: Array<{
      source_url: string;
      alt_text: string;
    }>;
  };
}

export interface BlogAuthor {
  id: number;
  name: string;
  slug: string;
}

// Fetch all blog posts
export const fetchBlogPosts = async (page: number = 1, perPage: number = 10): Promise<BlogPost[]> => {
  try {
    const response = await fetch(
      `${WP_API_BASE}/posts?page=${page}&per_page=${perPage}&_embed=author,wp:featuredmedia&status=publish`
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return [];
  }
};

// Fetch single blog post by slug
export const fetchBlogPost = async (slug: string): Promise<BlogPost | null> => {
  try {
    const response = await fetch(
      `${WP_API_BASE}/posts?slug=${slug}&_embed=author,wp:featuredmedia&status=publish`
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const posts = await response.json();
    return posts.length > 0 ? posts[0] : null;
  } catch (error) {
    console.error('Error fetching blog post:', error);
    return null;
  }
};

// Fetch blog post by ID
export const fetchBlogPostById = async (id: number): Promise<BlogPost | null> => {
  try {
    const response = await fetch(
      `${WP_API_BASE}/posts/${id}?_embed=author,wp:featuredmedia`
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog post by ID:', error);
    return null;
  }
};

// Fetch authors
export const fetchAuthors = async (): Promise<BlogAuthor[]> => {
  try {
    const response = await fetch(`${WP_API_BASE}/users`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching authors:', error);
    return [];
  }
};

// Helper function to strip HTML tags from content
export const stripHtml = (html: string): string => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

// Helper function to get excerpt
export const getExcerpt = (content: string, maxLength: number = 150): string => {
  const stripped = stripHtml(content);
  return stripped.length > maxLength 
    ? stripped.substring(0, maxLength) + '...'
    : stripped;
}; 